import React, {useState, useEffect} from 'react'
import {Link as RouterLink, useNavigate} from 'react-router-dom'
import {styled} from '@material-ui/core/styles'
import {
  Link,
  Stack,
  Container,
  Typography,
  Button,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import AlertTitle from '@material-ui/lab/AlertTitle'
import LocationNeededDialog12 from '../components/locationDialog'
import MigrationDialog from '../components/migrationDialog'

import Page from '../components/Page'
import Logo from '../components/Logo'
import {LoginForm, PhoneForm, VerifyCodeForm} from '../components/authentication/login_v2'
import storage from 'utils/storage'
import SecureLS from 'secure-ls'
import {useAuth} from 'components/SessionAuth'
import {useMediaQuery} from '@material-ui/core'
import {useTheme} from '@material-ui/core/styles'

const ls = new SecureLS({encodingType: 'aes'})

// Custom styled components for the new layout
const RootStyle = styled('div')(({theme}) => ({
  display: 'flex',
  height: '100vh',
  overflow: 'hidden',
}))

const LeftSide = styled(Box)(({theme}) => ({
  flex: 1,
  background: 'linear-gradient(135deg, #2FB7DE 0%, #23A6DC 25%, #1F99DC 50%, #4BBDE3 75%, #63CCE7 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  padding: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    display: 'none', // Hide on mobile
  },
}))

const RightSide = styled(Box)(({theme}) => ({
  flex: 1,
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    flex: 'none',
    width: '100%',
  },
}))

const ContentStyle = styled('div')(({theme}) => ({
  maxWidth: 400,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}))

const LogoContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
}))

const StyledLogo = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  '& img': {
    width: 80,
    height: 80,
    marginRight: theme.spacing(2),
  },
  '& .MuiTypography-root': {
    color: 'white !important',
    fontWeight: 'bold',
    fontSize: '1.5rem',
  },
}))

export default function Login() {
  const navigation = useNavigate()
  const {logout} = useAuth()
  const [isPhoneForm, setPhoneForm] = useState(false)
  const [isDialogOpen, setDialogOpen] = useState(false)
  const [steps, setSteps] = useState(1)
  const [permission, setPermission] = useState()
  const [user, setUser] = useState([])
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false)
  const [appVersion, setAppVersion] = useState(process.env.REACT_APP_VERSION)
  const handleStep = (_v) => {
    setSteps(_v)
  }
  // inside your Login component:
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleSignOut = async (e) => {
    e.preventDefault()
    await logout()
  }

  const handleSwitchForm = () => {
    setPhoneForm(true)
  }
  const handleEmailForm = () => {
    setPhoneForm(false)
  }
  const geolocation = async () => {
    await navigator.geolocation.watchPosition(function (position) {
      ls.set('latitude', position.coords.latitude)
      ls.set('longitude', position.coords.longitude)
    })
  }
  useEffect(() => {
    const load = async () => {
      const storedVersion = ls.get('appVersion')
      if (!storedVersion || storedVersion !== appVersion) {
        setUpdateDialogOpen(true)
      }
      /*if (storedVersion === undefined || storedVersion === null || storedVersion === "" || storedVersion !== appVersion) {
        const isWebView = navigator.userAgent.includes('wv') || // Android WebView
        navigator.userAgent.includes('Mobile/') && !navigator.userAgent.includes('Safari'); // iOS WebView
        setUpdateDialogOpen(true)
        ls.set("appVersion", "4.7.8")
      }*/
      const EXPIRY_TIME_IN_HOURS = 12
      const currentTime = new Date().getTime()
      const expiryTime = currentTime + EXPIRY_TIME_IN_HOURS * 60 * 60 * 1000
      ls.set('appVersion', appVersion)
      await geolocation()
      const local_user = await storage.getUser()
      if (!local_user) return false
      const user = JSON.parse(local_user)
      setUser(user)
    }
    load()
  }, [permission])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname.replace(/^www\./, '')
      if (hostname === 'timein.sparkles.com.ph') {
        setDialogOpen(true)
      }
    }
  }, [])

  const handleUpdateClose = () => {
    setUpdateDialogOpen(false)
    ls.set('appVersion', appVersion)
    // setTimeout(() => {
    //   window.location.reload();
    // }, 500);
  }

  return (
    <>
      <MigrationDialog open={isDialogOpen} onClose={() => setDialogOpen(false)} />

      <RootStyle>
        {/* Left Side - Gradient Background with Logo */}
        <LeftSide>
          <LogoContainer>
            <img src="/favicon/LOGO-12.png" alt="Dashboard Logo" style={{width: '100%', height: '100%'}} />
          </LogoContainer>
        </LeftSide>

        {/* Right Side - Login Form */}
        <RightSide>
          <ContentStyle>
            {isMobile && (
              <Box sx={{display: 'flex', justifyContent: 'center', mb: 7}}>
                <img src="/favicon/big-header-logo.svg" alt="Dashboard Logo" style={{width: '100%', height: '100%'}} />
              </Box>
            )}

            {user && (user.role === 1 || user.role >= 3) ? (
              <Alert severity="info" sx={{mb: 3}}>
                <AlertTitle>Issue</AlertTitle>
                You are currently signed in as Store <br />
                If you wish to sign in as employee kindly —
                <Button
                  color="inherit"
                  onClick={(e) => {
                    handleSignOut(e)
                  }}
                >
                  <strong>Sign out</strong>
                </Button>
              </Alert>
            ) : null}

            <Stack sx={{mb: 4}}>
              <Typography variant="h4" gutterBottom sx={{fontWeight: 'bold', color: '#333'}}>
                {steps === 2
                  ? 'Verify User'
                  : !isPhoneForm
                  ? 'Sign in using credentials'
                  : 'Sign in using mobile number'}
              </Typography>
              <Typography sx={{color: '#666', fontSize: '0.9rem'}}>
                {steps === 2
                  ? 'Kindly check your mobile phone for Six (6) Verification Code.'
                  : 'Enter your credentials to continue'}
              </Typography>
            </Stack>

            {!isPhoneForm ? (
              <>
                <LoginForm handleSwitchForm={handleSwitchForm} />
              </>
            ) : (
              <>
                {steps === 2 ? (
                  <VerifyCodeForm currentStep={handleStep} />
                ) : (
                  <>
                    <PhoneForm currentStep={handleStep} handleEmailForm={handleEmailForm} />
                  </>
                )}
              </>
            )}
          </ContentStyle>
        </RightSide>

        <Dialog open={updateDialogOpen} onClose={handleUpdateClose}>
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold">
              The app has been updated
            </Typography>
          </DialogTitle>
          <DialogContent>
            Your app has been updated to the latest version. Enjoy improved performance and new features!
          </DialogContent>
          <DialogActions>
            <Button onClick={handleUpdateClose} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </RootStyle>
    </>
  )
}
